import { GlobalController } from 'src/shared/global/GlobalController'
import TechnicalAssessment from './TechnicalAssessment'
const ifAuthenticated = (to, from, next) => {
  GlobalController.getAsyncInstance().then(data => {
    if (data && data.authResp && data.authResp.token) {
      next()
    } else {
      next('/')
    }
  })
}
export const routes = [
  {
    path: 'technical-assessment',
    name: 'TechnicalAssessment',
    component: TechnicalAssessment,
    beforeEnter: ifAuthenticated,
    props: true
  }
]
